import { type EditorState } from "@codemirror/state";
import { CodeMirror, CodeMirrorEditor } from "@handlewithcare/react-codemirror";

import { useTheme } from "@moment/design-system/ThemeProvider";

import { useEasel } from "../easel";
import { extensions } from "../easel/editor-state/createMarkdownEditorState";
import { usePageEditorState } from "../easel/usePageEditorState";

interface Props {
	editorState?: EditorState;
}

export function BigMarkdownEditor({ editorState }: Props) {
	const { pageId, documentId } = useEasel();
	const { applyTransaction } = usePageEditorState(documentId, pageId);

	const { resolvedTheme } = useTheme();
	const codeMirrorTheme = resolvedTheme === "light" ? "light" : "dark";

	if (!editorState) {
		return null;
	}

	return (
		<CodeMirror
			state={editorState}
			dispatchTransactions={(trs) => {
				trs.forEach((tr) => {
					applyTransaction({ createTransaction: () => tr });
				});
			}}
			extensions={extensions(codeMirrorTheme)}
		>
			<CodeMirrorEditor />
		</CodeMirror>
	);
}
